import React, { useEffect, useState } from 'react';
import { makeStyles, Theme, Typography, Button } from '@material-ui/core';
import { FUI } from '../../UrlFiles/UrlFiles';

const useStyles = makeStyles((theme: Theme) => ({
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f0f9ff 0%, #ffffff 50%, #e0f2fe 100%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px 16px',
    fontFamily: 'Arial, sans-serif',
  },
  card: {
    background: '#ffffff',
    borderRadius: '20px',
    border: '1px solid #e0f2fe',
    boxShadow: '0 4px 32px rgba(0, 191, 255, 0.10)',
    padding: '40px 36px',
    maxWidth: '480px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
    textAlign: 'center',
  },
  brandRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '6px',
    paddingBottom: '20px',
    borderBottom: '1px solid #e0f2fe',
    width: '100%',
  },
  brandLogoCircle: {
    width: '40px',
    height: '40px',
    borderRadius: '10px',
    background: '#f0f9ff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '4px',
  },
  brandName: {
    color: '#111827',
    fontWeight: 700,
    fontSize: '16px',
    margin: 0,
  },
  brandPowered: {
    color: '#00bfff',
    fontSize: '11px',
    fontWeight: 600,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  logo: {
  height: 60,
  width: 'auto',
  maxWidth: '260px',
  objectFit: 'contain',
},
  iconCircle: {
    width: '68px',
    height: '68px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  title: {
    color: '#111827',
    fontWeight: 700,
    fontSize: '20px',
    margin: '0 0 6px 0',
    lineHeight: 1.3,
  },
  subtitle: {
    color: '#6b7280',
    fontSize: '14px',
    lineHeight: 1.7,
    margin: 0,
    maxWidth: '360px',
  },
  infoBox: {
    borderRadius: '12px',
    padding: '14px 18px',
    width: '100%',
    fontSize: '13px',
    lineHeight: 1.65,
    textAlign: 'left',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
  },
  infoBoxRecruiter: {
    background: '#f0f9ff',
    border: '1px solid #bae6fd',
    color: '#0369a1',
  },
  infoBoxCandidate: {
    background: '#f0fdf4',
    border: '1px solid #bbf7d0',
    color: '#15803d',
  },
  button: {
    borderRadius: '12px !important',
    padding: '12px 32px !important',
    textTransform: 'none !important' as any,
    fontWeight: '600 !important' as any,
    fontSize: '14px !important',
    background: '#00bfff !important',
    color: '#ffffff !important',
    boxShadow: '0 2px 12px rgba(0,191,255,0.25) !important',
    width: '100%',
    '&:hover': {
      background: '#00a8e0 !important',
    },
  },
  countdown: {
    color: '#9ca3af',
    fontSize: '12px',
    marginTop: '8px',
    textAlign: 'center',
  },
  poweredBy: {
    marginTop: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    color: '#9ca3af',
    fontSize: '11px',
  },
  poweredByDot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    background: '#00bfff',
    display: 'inline-block',
  },
  
}));

export default function InterviewCompleteScreen() {
  const classes = useStyles();
  const params = new URLSearchParams(window.location.search);
  const role = params.get('role');
  const isRecruiter = role === 'recruiter';
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (isRecruiter) return;
    const t = setInterval(() => {
      setCountdown(c => {
        if (c <= 1) {
          clearInterval(t);
          window.location.href = FUI;
          return 0;
        }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [isRecruiter]);

  if (isRecruiter) {
    return (
      <div className={classes.page}>
        <div className={classes.card}>
          <div className={classes.brandRow}>
           
            <img
    src="https://storage.googleapis.com/itn-public-images/Job%20excello%20main%20logo%201.png"
    alt="JobExcello"
    className={classes.logo}
  />
          </div>

          <div className={classes.iconCircle} style={{ background: '#f0f9ff', border: '2px solid #bae6fd' }}>
            <svg width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="#00bfff" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.069A1 1 0 0121 8.87v6.26a1 1 0 01-1.447.9L15 14M3 8a2 2 0 012-2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" />
            </svg>
          </div>

          <div>
            <p className={classes.title}>Interview Session Ended</p>
            <p className={classes.subtitle}>
              The candidate has been disconnected and the session has been finalized.
            </p>
          </div>

          <div className={`${classes.infoBox} ${classes.infoBoxRecruiter}`}>
            <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="#0369a1" strokeWidth={2} style={{ flexShrink: 0, marginTop: '2px' }}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Your interview recording is being processed. AI analysis and the full report will be available on your dashboard in a few minutes.
          </div>

          <Button
            variant="contained"
            className={classes.button}
            onClick={() => { (window.top as Window).location.href = `${FUI}/dashboard/candidates/ai-assisted-interviews`; }}
          >
            Go to AI Interviews Dashboard
          </Button>
        </div>

      
      </div>
    );
  }

  return (
    <div className={classes.page}>
      <div className={classes.card}>
        <div className={classes.brandRow}>
           
            <img
    src="https://storage.googleapis.com/itn-public-images/Job%20excello%20main%20logo%201.png"
    alt="JobExcello"
    className={classes.logo}
  />
          </div>

        <div className={classes.iconCircle} style={{ background: '#f0fdf4', border: '2px solid #bbf7d0' }}>
          <svg width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="#22c55e" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <div>
          <p className={classes.title}>Interview Completed</p>
          <p className={classes.subtitle}>
            Thank you for attending. The recruiter will review your session and be in touch with you soon.
          </p>
        </div>

        <div className={`${classes.infoBox} ${classes.infoBoxCandidate}`}>
          <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="#15803d" strokeWidth={2} style={{ flexShrink: 0, marginTop: '2px' }}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Your interview has been successfully recorded and submitted for review.
        </div>

        <div style={{ width: '100%' }}>
          <Button
            variant="contained"
            className={classes.button}
            onClick={() => { window.location.href = FUI; }}
          >
            Go to JobExcello
          </Button>
          <p className={classes.countdown}>Redirecting automatically in {countdown}s…</p>
        </div>
      </div>

  
    </div>
  );
}